import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { formatCountdown } from './utils';

export default function RenderProgress({ renderStatus, voiceOverDuration }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (renderStatus?.status !== 'rendering') return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [renderStatus?.status]);
  const status = renderStatus?.status;
  if (status === 'queued')
    return (
      <Box sx={{ mb: 2 }}>
        <LinearProgress sx={{ borderRadius: 1 }} />
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Waiting in Queue
        </Typography>
      </Box>
    );
  if (status === 'setting_up')
    return (
      <Box sx={{ mb: 2 }}>
        <LinearProgress sx={{ borderRadius: 1 }} />
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Setting up cloud editing instance
        </Typography>
      </Box>
    );
  if (status === 'rendering') {
    const startedAt = renderStatus.renderStartedAt
      ? new Date(renderStatus.renderStartedAt).getTime()
      : now;
    const estimatedSec =
      renderStatus.estimatedDurationSec ||
      Math.ceil((voiceOverDuration || 60) / 3.8);
    const elapsed = (now - startedAt) / 1000;
    const remaining = Math.max(0, estimatedSec - elapsed);
    const progress = Math.min(99, Math.round((elapsed / estimatedSec) * 100));
    return (
      <Box sx={{ mb: 2 }}>
        <LinearProgress
          variant='determinate'
          value={progress}
          sx={{ borderRadius: 1 }}
        />
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Rendering — {formatCountdown(remaining)} remaining ({progress}%)
        </Typography>
      </Box>
    );
  }
  if (status === 'finalizing')
    return (
      <Box sx={{ mb: 2 }}>
        <LinearProgress sx={{ borderRadius: 1 }} />
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Finalizing
        </Typography>
      </Box>
    );
  return null;
}
